import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M0 130.96c0-32.88 26.651-59.531 59.531-59.531h380.937C473.343 71.429 500 98.08 500 130.96v238.08c0 32.874-26.657 59.531-59.532 59.531H59.531C26.651 428.571 0 401.914 0 369.04zm59.531-35.714c-19.737 0-35.714 15.977-35.714 35.714v238.08c0 19.731 15.977 35.714 35.714 35.714h380.937c19.732 0 35.715-15.983 35.715-35.714V130.96c0-19.737-15.983-35.714-35.715-35.714z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M333.326 238.103c-13.149 0-23.8-10.674-23.8-23.817 0-13.149 10.651-23.817 23.8-23.817 7.611 0 14.394 3.571 18.771 9.148l18.749-14.663c-8.703-11.12-22.275-18.28-37.52-18.28-26.298 0-47.612 21.315-47.612 47.612 0 26.291 21.314 47.611 47.612 47.611 14.102 0 26.782-6.143 35.485-15.874l-17.72-15.869c-4.4 4.886-10.714 7.949-17.771 7.949z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M392.857 238.103c-13.149 0-23.817-10.674-23.817-23.817 0-13.149 10.668-23.817 23.817-23.817 13.143 0 23.817 10.668 23.817 23.817 0 13.143-10.674 23.817-23.817 23.817m-47.611-23.817c0 26.291 21.314 47.611 47.611 47.611 26.291 0 47.611-21.32 47.611-47.611 0-26.297-21.32-47.612-47.611-47.612-26.297 0-47.611 21.315-47.611 47.612M0 333.326c0 6.583 5.331 11.914 11.897 11.914h476.206c6.56 0 11.897-5.331 11.897-11.914 0-6.566-5.337-11.897-11.897-11.897H11.897C5.331 321.429 0 326.76 0 333.326"
    }, null, -1)
  ])))
}
export default { render: render }